export const MENU_WIDTH = 420;

export const ACTION = {
  addBrandBrief: 'add_brand_brief',
  insertBrandBrief: 'insert_brand_brief',
  insertExternalChannelItems: 'insert_external_channel_items',

  insertUrl: 'insert_url',
  insertDocument: 'insert_document',
  insertImage: 'insert_image',
  insertVariable: 'insert_variable',
  removePromptImage: 'remove_prompt_image',
  removeUploadingImage: 'remove_uploading_image',
  removePromptDocument: 'remove_prompt_document',
  removeUploadingDocument: 'remove_uploading_document',
  insertInstruction: 'insert_instruction',

  uploadResourceFile: 'upload_resource_file',

  suggestPrompt: 'suggest_prompt',
  savePrompt: 'save_prompt',
  openResourceInNewTab: 'open_resource_in_new_tab',
  clearVariationRatings: 'clear_variation_ratings',

  displayMessage: 'display_message',
  displayError: 'display_error',
  trackEvent: 'track_event',
};
